/**
 * A card of the statistics page, as in the prototype: its title, what sits
 * on its right (`aside`) and its content.
 */
const StatsCard = ({ title, aside, children, className = '' }) => (
  <section
    className={`flex flex-col gap-4 rounded-2xl border border-gray-100 bg-white p-5 ${className}`}
  >
    <div className="flex items-center gap-2">
      <h2 className="text-sm font-semibold leading-5 tracking-[-0.23px] text-gray-900">
        {title}
      </h2>
      <span className="flex-1" />
      {aside}
    </div>
    {children}
  </section>
);

// The grey words on the right of a card's title.
export const CardAside = ({ children }) => (
  <span className="text-xs leading-4 text-gray-400">{children}</span>
);

export default StatsCard;
